import React , { RefObject } from "react";
import { PieChart, Pie, Legend, Tooltip } from "recharts";
import { DataHelper } from "../Helpers/DataHelper";
import { ChartDataModel } from "../Models/ChartDataModel";
import { LoadingWidget } from "../Components/LoadingWidget";
import { ErrorWindow } from "../Components/ErrorWindow";

export class MeasurementTypesPerStudy extends React.Component<
    {
        dataClient: DataHelper,
        studyId: string
    },
    {
        measurementData: ChartDataModel[],
        isBusy: boolean
    }
> {

    //Data structure: 
    // data = [
    //     { name: "category", value: number, fill: '#color' }
    // ];

    renderCustomizedLabel = ({
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        percent,
        index,
    }: {
        cx: number;
        cy: number;
        midAngle: number;
        innerRadius: number;
        outerRadius: number;
        percent: number;
        index: number;
    }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="#4A4A4A"
                textAnchor="middle"
                dominantBaseline="middle"
            >
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    style = {
        top: 0,
        left: 350,
        lineHeight: "24px"
    };

    errorWindow:  RefObject<ErrorWindow>;
    constructor(props: any) {
        super(props);
        this.errorWindow = React.createRef();
        this.state = {
            measurementData: [],
            isBusy: false
        }
    }

    getData = (studyId: string): void => {
        this.setState({ isBusy: true })
        this.props.dataClient.CallDashboardService("GetMeasurementTypesPerStudy", {}, {studyId: this.props.studyId}, (result: string) => {
            let measurementTypes = JSON.parse(result);
            const colors = ['#F5812E', '#45BCB4', '#9FB6E8', '#91837A', '#F2C94C', '#7FC29B', '#E6E0D8', '#D99A6C', '#B7C9E2', '#D6D96F', '#E3B6CC', '#9FA1A4']
;
            for (let index = 0; index < measurementTypes.length; index++) {
                const element = measurementTypes[index];
                element.fill = colors[index % colors.length];
            }
            this.setState({ measurementData: measurementTypes, isBusy: false })
        }, (stautus:number, errorMessage:string)=>{
            (this.errorWindow.current as ErrorWindow).show(stautus, errorMessage)}, "GET", false)}
    
    componentDidMount(): void {}

    render() {

        return (
            <>
            <ErrorWindow ref={this.errorWindow}/>
            <h3>Measurement types</h3>
                <div className="chartHolder">
                
                    <PieChart width={520} height={320}>
                        <Pie
                            dataKey="value1"
                            data={this.state.measurementData}
                            cx={150}
                            cy={150}
                            outerRadius={120}
                            labelLine={false}
                            label={this.renderCustomizedLabel}
                        />
                        <Tooltip />
                        <Legend
                            layout="vertical"
                            align="right"
                            height={300}
                            width={200}
                        />
                    </PieChart>
                    <LoadingWidget visible={this.state.isBusy} zIndexLayer={0}></LoadingWidget>
                </div>
            </>
        );
    }
}
